module.exports = __webpack_public_path__ + "img/invest-management.ec88c2f5.svg";